export const associatesTypes = [
    {
        item: 'Workers',
        sub_items: [
            {
                item: 'Aluminum fabrication'
            },
            {
                item: 'Artist'
            },
            {
                item: 'Electrician'
            },
            {
                item: 'Engineer'
            },
            {
                item: 'Painter'
            },
            {
                item: 'Plumber'
            },
            {
                item: 'other'
            },
        ]
    },
    {
        item: 'BNI',
        sub_items: [
            {
                item: 'Kodungallur'
            },
            {
                item: 'Thriprayar'
            },
            {
                item: 'Thrissur'
            },
            {
                item: 'other'
            },
        ]
    },
    {
        item: "Adz",
        sub_items: [
            {
                item: 'Online'
            },
            {
                item: 'Offline'
            }
        ]
    }
]

export const productTypes = ['VESSEL_FILTER', "WATER_PURIFIER", "ADD_ON"]

export const featureTypes = [
    'BRAND',
    "COLOR",
    "COLOR_CODE",
    "SIZE"
]

export const spareCategories = [
    // Purifier
    "CABIN",
    "5 MICRON",
    "PUMP",
    "MEMBRANE",
    "SEDIMENT",
    "PRE-CARBON",
    "POST-CARBON",
    "SV",
    "ADAPTER",
    "PR_SPARE_PARTS",

    // Vessel
    "MATERIAL",
    "MATERIALS_BAG",
    "VESSEL",
    "VALVE",
    "VF_SPARE_PARTS",

    // Add-ons
    "CHEMICALS",
    "ADD_ON_SPARE_PARTS"
]


export const UNITS = [
    { name: "Liter", short: "L" },
    { name: "Milliliter", short: "mL" },
    { name: "Kilogram", short: "kg" },
    { name: "Gram", short: "g" },
    { name: "Milligram", short: "mg" },
    { name: "Number of", short: "nos" },
    { name: "Centimeter", short: "cm" },
    { name: "Millimeter", short: "mm" },
    { name: "Meter", short: "m" },
    // { name: "Kilometer", short: "km" },
    // { name: "Square Meter", short: "m²" },
    // { name: "Cubic Meter", short: "m³" },
    // { name: "Kilowatt", short: "kW" },
    // { name: "Watt", short: "W" },
    // { name: "Second", short: "s" },
    // { name: "Minute", short: "min" },
    // { name: "Hour", short: "hr" },
    // { name: "Day", short: "day" },
    // { name: "Week", short: "week" },
    // { name: "Month", short: "month" },
    // { name: "Year", short: "year" },
    // { name: 'Visit', short: 'visit' }
];

export const price_units = ['PURCHASE_COST', 'PACKAGE_PRICE', 'SELLING_RATE']